export const ListSizeConfig = {
    height: 440,
    lensHeight: 48,
};
